module.exports = __webpack_public_path__ + "img/erro_cadastro.1e08a02f.svg";